<template>

	<div class="preHeader">
		<h3 style="color:#FBFBFF">
			Our platform grants you the freedom to journey through the cosmos and witness the dynamic interplay of Vedic planets at your chosen date and time. 
			Whether you're curious about the planetary alignments at birth, seeking insight into current transits, or planning auspicious moments for important events, our tool offers precise planetary positions with Panchanga (Vedic Almanac) at your fingertips!	
		</h3>
	</div>

	<div class="screen-wrapper">

		<div class="planetary-positions-intro-wrapper" v-if="firstVisit">
			<div class="planetary-positions-intro">
					<u>
						<h3>Planetary Positions</h3>
					</u>

					<p style="text-align: justify;">
						Our platform grants you the freedom to journey through the cosmos and witness the dynamic interplay of Vedic planets at your chosen date and time. 
					</p>

					<p style="text-align: justify;">
						Whether you're curious about the planetary alignments at birth, seeking insight into current transits, or planning auspicious moments for important events, our tool offers precise planetary positions with Panchanga (Vedic Almanac) at your fingertips!
					</p>				
			</div>		

			<div class="link-button-area">
				<a @click="viewPlanetaryPositions" class="link-button">
					View Planetary Positions
				</a>
			</div>
		</div>

		<div class="desktop-planetary-positions" v-if="deviceType=='BS' && !firstVisit">
			<PlanetaryPositions />
		</div>

		<div class="mobile-planetary-positions" v-if="deviceType=='SS' && !firstVisit">
			<MobilePlanetaryPositions />
		</div>

	</div>


</template>

<script>
import PlanetaryPositions from '@/components/PlanetaryPositions'
import MobilePlanetaryPositions from '@/components/MobilePlanetaryPositions'

export default {
	components: { PlanetaryPositions, MobilePlanetaryPositions },
	data() {
		return {
			deviceType: (window.innerWidth > 1205 ? 'BS' : 'SS'),
			firstVisit: localStorage.getItem('pploc') ? false : true
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		})
	},	
	beforeUnmount() { 
		window.removeEventListener('resize', this.onResize); 
	},

	methods: {  
		onResize() {
			this.deviceType = (window.innerWidth > 1205 ? 'BS' : 'SS')
		},
		viewPlanetaryPositions() {
			this.firstVisit = false
		}
	}
  }
</script>

<style scoped>

.preHeader {
	display:none !important;
	visibility: hidden !important;
	color: #FBFBFF !important;
	text-align: center;
}      

.screen-wrapper {
  border: 0px solid;
  display: block;
  clear: both;
  align-content: center;
  margin: 0;
  width: 100%;
  height: 95%;
  display:flex;
  justify-content:center; 
}

.desktop-planetary-positions {
	border: 0px solid;
	width:100%;
	height: 95%;
	margin-top:0px;
}

.mobile-planetary-positions {
	border: 0px solid;
	width:100%;
	height: 95%;
	margin-top:0px;
}

.planetary-positions-intro-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;  
    border-radius: 10px;
    padding-top: 10px;
  }

.planetary-positions-intro {
  border: 1px solid;
  border-color: #a0a0a0;
  align-content: center;
  background: #EDF6F9;
  border-radius: 10px;
  margin-top: 50px;
  width: 45%;
  padding: 15px;
  
}

.link-button {
  border-radius: 5px;
  background-color: #087F8C;
  color: #FFFFFF;
  font-weight: bold;
  font-size: 20px;
  padding: 12px;
  text-decoration: none;
  cursor: pointer;
}

.link-button-area {
  width: 95%;
  border: 0px solid;
  padding: 30px;
}


@media screen and (max-width: 1205px) {

	.planetary-positions-intro {
		border: 1px solid;
		border-color: #a0a0a0;
		align-content: center;
		background: #EDF6F9;
		border-radius: 10px;

		padding: 10px;
		margin-top: 10%;
		width: 90%;
	}

}

</style>
